import $ from 'jquery';

const multiSelect = (uniq) => {
  const $uniq = $(uniq);
  const $uniqEl = $(uniq)[0];
  const $content = $uniq.parents('.individual-accordion').find('.collapse')[0];
  const promise = new Promise((resolve) => {
    let uniqArrow;
    for (let i = $uniqEl.children.length - 1; i >= 0; i -= 1) {
      if ($uniqEl.children[i].tagName === 'svg') {
        uniqArrow = $uniqEl.children[i];
      }
    }
    resolve(uniqArrow);
  });
  promise.then((uniqArrow) => {
    if ($($content).hasClass('shows')) {
      $($content).slideUp().removeClass('shows');
      $(uniqArrow).removeClass('down').addClass('right');
      $($uniqEl).removeClass('active').removeAttr('data-ct-ignore');
    } else {
      $($content).slideDown().addClass('shows');
      $($uniqEl).addClass('active').attr('data-ct-ignore', true);
      $(uniqArrow).removeClass('right').addClass('down');
    }
  });
};

const singleSelect = (uniq) => {
  const $uniq = $(uniq);
  const $uniqEl = $(uniq)[0];
  const $content = $uniq.parents('.individual-accordion').find('.collapse')[0];
  const promise = new Promise((resolve) => {
    let uniqArrow;
    for (let i = $uniqEl.children.length - 1; i >= 0; i -= 1) {
      if ($uniqEl.children[i].tagName === 'svg') {
        uniqArrow = $uniqEl.children[i];
      }
    }
    resolve(uniqArrow);
  });

  promise.then((uniqArrow) => {
    if ($($content).hasClass('shows')) {
      $($content).slideUp().removeClass('shows');
      $($uniq.parents('.heavy-accordion-holder, .light-accordion-holder')[0]).find('svg').removeClass('down').addClass('right');
      $($uniqEl).removeClass('active').removeAttr('data-ct-ignore');
    } else {
      $($uniq.parents('.heavy-accordion-holder, .light-accordion-holder')[0]).find('.collapse.single-slct').slideUp().removeClass('shows');
      $($content).slideDown().addClass('shows');
      $($uniq.parents('.heavy-accordion-holder, .light-accordion-holder')[0]).find('.accordion-title-single').removeClass('active');
      $($uniq.parents('.heavy-accordion-holder, .light-accordion-holder')[0]).find('svg').removeClass('down').addClass('right');
      $($uniqEl).addClass('active').attr('data-ct-ignore', true);
      $(uniqArrow).removeClass('right').addClass('down');
    }
  });
};

const toggleAccordion = (uniq) => {
  const $uniq = $(uniq);
  const $uniqEl = $(uniq)[0];
  const $content = $uniq.parents('.individual-inline-accordion, .show-more-expander').find('.collapse')[0];
  const controlText = $uniq.parents('.individual-inline-accordion, .show-more-expander').find('.expand-control-text')[0];
  const promise = new Promise((resolve) => {
    let collapseText;
    let expandText;
    for (let i = controlText.attributes.length - 1; i >= 0; i -= 1) {
      if (controlText.attributes[i].name === 'data-accordion-collapse-text') {
        collapseText = controlText.attributes[i].value;
      } else if (controlText.attributes[i].name === 'data-accordion-expand-text') {
        expandText = controlText.attributes[i].value;
      }
    }
    const attrs = {
      collapseText,
      expandText
    };
    resolve(attrs);
  });

  promise.then((attrs) => {
    let uniqArrow;
    let uniqCtrlText;
    for (let i = $uniqEl.children.length - 1; i >= 0; i -= 1) {
      if ($uniqEl.children[i].tagName === 'svg') {
        uniqArrow = $uniqEl.children[i];
      } else if ($uniqEl.children[i].className === 'expand-control-text') {
        uniqCtrlText = $uniqEl.children[i];
      }
    }
    const allItems = Object.assign({}, attrs, { uniqArrow, uniqCtrlText });
    return allItems;
  }).then((allItems) => {
    if ($($content).hasClass('shows')) {
      $($content).slideUp().removeClass('shows');
      $(allItems.uniqArrow).removeClass('down up').addClass('right');
      $(allItems.uniqCtrlText).text(allItems.expandText).removeAttr('data-ct-ignore');
    } else {
      $($content).slideDown().addClass('shows');
      if ($(allItems.uniqArrow).parents('.show-more-control-inline')[0]) {
        $(allItems.uniqArrow).removeClass('right').addClass('up');
      } else {
        $(allItems.uniqArrow).removeClass('right').addClass('down');
      }
      $(allItems.uniqCtrlText).text(allItems.collapseText).attr('data-ct-ignore', true);
    }
  });
};

export const initMultiSelect = () => {
  $('.accordion-title').on('click', (e) => {
    e.preventDefault();
    multiSelect(e.currentTarget);
  });
};

export const initSingleSelect = () => {
  $('.accordion-title-single').on('click', (e) => {
    e.preventDefault();
    singleSelect(e.currentTarget);
  });
};

export const initInlineSelect = () => {
  $('.accordion-control-inline, .show-more-control-inline').on('click', (e) => {
    e.preventDefault();
    toggleAccordion(e.currentTarget);
  });
};

export const initExpDefault = () => {
  const expDef = $('.exp-default').children('a');
  expDef.each((index, el) => multiSelect(el));
};

export default () => {
  initMultiSelect();
  initSingleSelect();
  initInlineSelect();
  initExpDefault();
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/accordions.js